import { useTheme } from "../theme";
import lightLogo from "../assets/logo.svg";
import darkLogo from "../assets/darkThemelogo.svg";

var useDefaultLogo = function useDefaultLogo() {
  var _useTheme = useTheme(),
      currentTheme = _useTheme.currentTheme;

  return currentTheme === 'light' ? lightLogo : darkLogo;
};

export default useDefaultLogo;